import { useList } from "@refinedev/core";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { PageHeader } from "@/components/forms/PageHeader";
import { MoneyDisplay } from "@/components/forms/MoneyDisplay";
import { EstadoBadge } from "@/components/forms/EstadoBadge";
import { formatDate } from "@/lib/formatters";

interface Periodo {
  id: string;
  numero_correlativo: number;
  fecha_inicio: string;
  fecha_fin: string;
  estado: "abierto" | "cerrado_tienda" | "liquidado" | "pagado" | "anulado";
  cantidad_ventas: number;
  total_ventas: number;
  valor_final_transferencia: number;
}

export function CortesListPage() {
  const { user, isAdmin, loading: authLoading } = useAuth();
  const { data, isLoading } = useList<Periodo>({
    resource: "periodos_cobro",
    filters: !isAdmin && user?.tienda_id
      ? [{ field: "tienda_id", operator: "eq", value: user.tienda_id }]
      : [],
    sorters: [{ field: "numero_correlativo", order: "desc" }],
    queryOptions: { enabled: !authLoading },
  });

  if (authLoading) {
    return <div className="card p-8 text-center text-fg-muted">Cargando...</div>;
  }

  return (
    <div>
      <PageHeader title="Cuentas de cobro" subtitle="Cortes de cada periodo" />
      {isLoading ? (
        <div className="card p-8 text-center text-fg-muted">Cargando...</div>
      ) : (
        <ul className="space-y-2">
          {data?.data.map((p) => (
            <li key={p.id}>
              <Link to={`/cuentas-cobro/${p.id}`} className="card p-4 hover:bg-bg block">
                <div className="flex items-start justify-between gap-3 flex-wrap">
                  <div>
                    <p className="font-medium">Corte #{p.numero_correlativo}</p>
                    <p className="text-sm text-fg-muted">
                      {formatDate(p.fecha_inicio)} — {formatDate(p.fecha_fin)}
                    </p>
                    <p className="text-sm text-fg-muted">{p.cantidad_ventas} ventas</p>
                  </div>
                  <div className="text-right space-y-1">
                    <EstadoBadge estado={p.estado === "anulado" ? "anulado" : p.estado} />
                    {p.valor_final_transferencia > 0 && (
                      <MoneyDisplay
                        value={p.valor_final_transferencia}
                        className="font-medium text-sm"
                      />
                    )}
                  </div>
                </div>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
